<template>
  <CardComponent>
    <div class="w-100">
      <p class="mb-3 font-size-14-600">{{ title }}</p>

      <div class="d-flex align-center">
        <div class="pl-3">
          <div class="round-primary-button primary-background-button-color">
            <Icon :icon="icon" color="white"></Icon>
          </div>
        </div>

        <slot name="customContent">
          <div :class="emptyContentCustomClass" class="ml-3 py-2">
            <p class="font-20">{{ subTitle }}</p>
            <p class="font-14">{{ firstRow }}</p>
            <p class="font-14">{{ secondRow }}</p>
          </div>
        </slot>
      </div>
    </div>
  </CardComponent>
</template>

<script lang="ts" setup>
import CardComponent from "@/components/custom/CardComponent.vue";
import Icon from "@/components/Icons/Icon.vue";
import {defineProps} from 'vue';

const props = defineProps({
  icon: {
    type: String,
    default: 'calendar-icon-thin'
  },
  title: {
    type: String,
    default: 'Events'
  },
  subTitle: {
    type: String,
    default: 'Upcoming Event'
  },
  firstRow: {
    type: String,
    default: 'You have no booked'
  },
  secondRow: {
    type: String,
    default: 'events'
  },
  emptyContentCustomClass: {
    type: String,
    default: ''
  }
})
</script>

<style lang="scss" scoped>
.font-20 {
  font-size: 18px;
  font-weight: 600;
}

.font-14 {
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
}
</style>